export var ConditionalRuleDataTypeEnum;
(function (ConditionalRuleDataTypeEnum) {
    ConditionalRuleDataTypeEnum[ConditionalRuleDataTypeEnum["CURRENCY"] = 0] = "CURRENCY";
    ConditionalRuleDataTypeEnum[ConditionalRuleDataTypeEnum["PERCENT"] = 1] = "PERCENT";
    ConditionalRuleDataTypeEnum[ConditionalRuleDataTypeEnum["HOURS"] = 2] = "HOURS";
    ConditionalRuleDataTypeEnum[ConditionalRuleDataTypeEnum["STRING"] = 3] = "STRING";
    ConditionalRuleDataTypeEnum[ConditionalRuleDataTypeEnum["DATE"] = 4] = "DATE";
    ConditionalRuleDataTypeEnum[ConditionalRuleDataTypeEnum["PARTS"] = 5] = "PARTS";
    ConditionalRuleDataTypeEnum[ConditionalRuleDataTypeEnum["ARRAY"] = 6] = "ARRAY";
    ConditionalRuleDataTypeEnum[ConditionalRuleDataTypeEnum["YEAR"] = 7] = "YEAR";
    ConditionalRuleDataTypeEnum[ConditionalRuleDataTypeEnum["DISTANCE"] = 8] = "DISTANCE";
    ConditionalRuleDataTypeEnum[ConditionalRuleDataTypeEnum["VEHICLES"] = 9] = "VEHICLES";
    ConditionalRuleDataTypeEnum[ConditionalRuleDataTypeEnum["OPERATOR"] = 10] = "OPERATOR";
})(ConditionalRuleDataTypeEnum || (ConditionalRuleDataTypeEnum = {}));
//# sourceMappingURL=DataTypes.js.map